import React from 'react';
import { DefaultValues, SubmitHandler } from 'react-hook-form';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import CheckListForm from '../../components/CheckListForm';
import { ICheckList } from '../../components/CheckListForm/schema';

interface IProps {
  defaultValues: DefaultValues<ICheckList>;
  onSubmit: SubmitHandler<ICheckList>;
}

const EditCheckListView: React.FC<IProps> = ({ defaultValues, onSubmit }) => (
  <Card>
    <CardHeader>
      <CardTitle>Edit Check List</CardTitle>
      <CardDescription>Edit the check list for your hang tags.</CardDescription>
    </CardHeader>

    <CardContent className="p-4 space-y-4">
      <CheckListForm
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        submitText="Save Check List"
      />
    </CardContent>
  </Card>
);

export default EditCheckListView;
